import React from "react"
import {Segmented, Select} from "antd"
import {ChevronDown} from "lucide-react"
import {useTranslation} from "react-i18next"
import {apiSlices, store} from "../../features/store"
import {setDayjsLanguage} from "../../utils/dayjs"
import {AdminLanguage, isAdminLanguage, saveAdminLanguage} from "../../utils/language"
import {translateUi} from "../../i18n/translateUi"

interface LanguageSwitcherProps {
    compact?: boolean
    className?: string
}

const languageOptionLabel = (flag: string, label: string) => (
    <span className="admin-language-option">
        <span className="admin-language-option__flag" aria-hidden="true">{flag}</span>
        <span className="admin-language-select__name">{label}</span>
    </span>
)

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({compact = false, className}) => {
    const {i18n, t} = useTranslation()
    const currentLanguage: AdminLanguage = isAdminLanguage(i18n.resolvedLanguage)
        ? i18n.resolvedLanguage
        : "ru"

    const changeLanguage = async (value: string | number) => {
        if (!isAdminLanguage(value) || value === currentLanguage) return

        saveAdminLanguage(value)
        setDayjsLanguage(value)
        await i18n.changeLanguage(value)
        apiSlices.forEach((api) => store.dispatch(api.util.resetApiState()))
    }

    if (compact) {
        return (
            <Select
                aria-label={t("common.language")}
                className={["admin-language-select", className].filter(Boolean).join(" ")}
                value={currentLanguage}
                options={[
                    {label: languageOptionLabel("🇷🇺", translateUi("Русский")), value: "ru"},
                    {label: languageOptionLabel("🇺🇿", "O‘zbekcha"), value: "uz"}
                ]}
                onChange={changeLanguage}
                popupMatchSelectWidth={false}
                popupClassName="admin-language-select-popup"
                suffixIcon={<ChevronDown className="admin-language-select__chevron" />}
            />
        )
    }

    return (
        <Segmented
            aria-label={t("common.language")}
            className={["admin-language-switcher", className]
                .filter(Boolean)
                .join(" ")}
            size="small"
            value={currentLanguage}
            options={[
                {label: translateUi("Русский"), value: "ru"},
                {label: "O‘zbekcha", value: "uz"}
            ]}
            onChange={changeLanguage}
        />
    )
}

export default LanguageSwitcher
